import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';

import { Grid } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { getUserID, USER_API_URL } from '../../constants';
import axios from 'axios';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  header: {
    fontSize: '1.2rem',
  },
  passInfo: {
    paddingLeft: '20px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0',
    },
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#0d4d96',
    color: theme.palette.common.white,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  body: {
    fontSize: 14,
    '&:first-child': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  root: {},
}))(TableCell);

class QuizResDialog extends Component {
  constructor(props) {
    super(props);
    const arrQuiz = [
      {
        quizSession: 'Musculoskeletal Ultrasound Workshop I - Advance Course (KOR)',
        polls: [
          'evt002_poll001',
          'evt002_poll002',
          'evt002_poll003',
          'evt002_poll004',
          'evt002_poll005',
          'evt002_poll006',
          'evt002_poll007',
          'evt002_poll008',
          'evt002_poll009',
        ],

        quizNo: ['Quiz1', 'Quiz2', 'Quiz3', 'Quiz4', 'Quiz5', 'Quiz6', 'Quiz7', 'Quiz8', 'Quiz9'],
        answer: [0, 1, 2, 2, 2, 2, 1, 4, 4],
      },
    ];
    const quizNo = ['Quiz1', 'Quiz2', 'Quiz3', 'Quiz4', 'Quiz5', 'Quiz6', 'Quiz7', 'Quiz8', 'Quiz9'];

    this.state = {
      arrQuiz: arrQuiz,
      maxCount: quizNo,
      open: this.props.open,
      quizOpen: false,
      quizScore: 0,
      quizPass: false,
      quizIdx: this.props.quizIdx,
      remainCount: 3,
      matches: window.matchMedia('(max-width:600px)').matches,
    };

    this.getUserData = this.getUserData.bind(this);
    this.correctCount = this.correctCount.bind(this);
  }

  componentDidMount() {
    this.getUserData();
    // console.log('문제갯수: ' + this.state.maxCount.length);
    // console.log(this.state.maxCount);
    // console.log(this.state.arrQuiz);
    //this.state.arrQuiz[0].answer[i] -> 정답
    //this.props.userData['evt_002_poll001'] -> 사용자 입력답

    //this.state.arrQuiz[0].answer[this.state.arrQuiz[0].polls[i]]
    //this.props.userData[i]

    // console.log(this.props.userData);
    this.setState({ remainCount: Number(this.state.remainCount) - Number(this.props.quizCnt) });
  }

  handleClose(_val) {
    if (_val === 'Y') {
      // if (this.props.quizCnt > 0) {
      if (3 - Number(this.props.quizCnt) > 0) {
        this.props.onClose();
        this.setState({ quizOpen: true });
      } else {
        alert('남은 재시험 횟수가 0이므로, 퀴즈를 종료합니다.');
        this.props.onClose();
      }
    } else if (_val === 'N') {
      this.props.onClose();
    }
  }

  getUserData() {
    try {
      axios.get(`${USER_API_URL}/user/info?eventId=evt002&userId=${getUserID()}`, { headers: { Pragma: 'no-cache' } }).then((res) => {
        // console.log(res.data.Item);
        //   if (res.data.Item && res.data.Item.isLeadership === 'Y') {
        //     this.setState({ openAttendPopup: true });
        //   }

        this.setState({ myInfo: res.data.Item });
        this.correctCount();
      });
    } catch (e) {
      console.error(e);
    }
  }

  correctCount() {
    let score = 0;
    for (let i = 0; i < this.state.maxCount.length; i++) {
      if (Number(this.state.arrQuiz[0].answer[i]) === Number(this.props.userData[this.state.arrQuiz[0].polls[i]])) {
        score = score + 1;
      }
    }
    this.setState({ quizScore: score });
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Dialog
          onClose={this.props.onClose}
          open={this.props.open}
          // disableBackdropClick={true}
          // disableEscapeKeyDown={true}
          maxWidth={'md'}
          aria-labelledby="quiz-result-dialog-title"
          aria-describedby="quiz-result-dialog-description"
        >
          <DialogTitle>Quiz 결과</DialogTitle>
          <DialogContent>
            <TableContainer className={classes.customtable} style={{ padding: '20px' }}>
              {this.state.matches ? (
                <Table className={classes.table} aria-label="mobile">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>QUIZ No</StyledTableCell>
                      <StyledTableCell>ANSWER</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  {this.state.arrQuiz.map((item, i) => {
                    return (
                      <TableBody key={'mobile-table-body-' + i}>
                        {item.quizNo.map((no, n) => {
                          return (
                            <TableRow key={'mobile-score-row-' + n}>
                              <StyledTableCell style={{ textAlign: 'center' }}>{no}</StyledTableCell>
                              <StyledTableCell style={{ textAlign: 'center' }}>
                                {isNaN(Number(this.props.userData[item.polls[n]]))
                                  ? '-'
                                  : Number(this.props.userData[item.polls[n]]) === Number(item.answer[n])
                                  ? 'O'
                                  : 'X'}
                              </StyledTableCell>
                            </TableRow>
                          );
                        })}
                        <TableRow>
                          <StyledTableCell style={{ textAlign: 'center' }}>점수</StyledTableCell>
                          <StyledTableCell style={{ textAlign: 'center' }}>{this.props.quizScore}</StyledTableCell>
                        </TableRow>
                        <TableRow>
                          <StyledTableCell style={{ textAlign: 'center' }}>합격여부</StyledTableCell>
                          <StyledTableCell style={{ textAlign: 'center' }}>{this.props.quizScore >= 6 ? '합격' : '불합격'}</StyledTableCell>
                        </TableRow>
                        {this.props.quizScore < 6 && (
                          <TableRow>
                            <StyledTableCell style={{ textAlign: 'center' }}>남은 재시험 횟수</StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'center' }}>{3 - Number(this.props.quizCnt)}</StyledTableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    );
                  })}
                </Table>
              ) : (
                <Table className={classes.table} aria-label="web">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>QUIZ No</StyledTableCell>
                      {this.state.maxCount.map((quiz, quizIdx) => {
                        return <StyledTableCell key={'header-cell-' + quizIdx}>{quiz}</StyledTableCell>;
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.arrQuiz.map((item, i) => {
                      return (
                        <TableRow key={'session-row-' + i}>
                          <StyledTableCell style={{ textAlign: 'center' }}>CORRECT</StyledTableCell>
                          {item.polls.map((pollItem, p) => {
                            // console.log('사용자입력답: ' + this.props.userData[pollItem]);
                            // console.log('정답: ' + item.answer[p]);

                            return (
                              <StyledTableCell style={{ textAlign: 'center' }} key={'sub-cell3-' + p}>
                                {isNaN(Number(this.props.userData[pollItem]))
                                  ? '-'
                                  : Number(this.props.userData[pollItem]) === Number(item.answer[p])
                                  ? 'O'
                                  : 'X'}
                                {/* {Number(this.props.userData[pollItem]) === Number(item.answer[i]) ? 'O' : 'X'} */}
                              </StyledTableCell>
                            );
                          })}
                          {this.state.arr}
                        </TableRow>
                      );
                    })}
                    <TableRow>
                      <StyledTableCell style={{ textAlign: 'center' }}>점수</StyledTableCell>
                      <StyledTableCell colSpan={this.state.maxCount.length} style={{ textAlign: 'center' }}>
                        {this.props.quizScore}
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableCell style={{ textAlign: 'center' }}>합격여부</StyledTableCell>
                      <StyledTableCell colSpan={this.state.maxCount.length} style={{ textAlign: 'center' }}>
                        {this.props.quizScore >= 6 ? '합격' : '불합격'}
                      </StyledTableCell>
                    </TableRow>
                    {this.props.quizScore < 6 && (
                      <TableRow>
                        <StyledTableCell style={{ textAlign: 'center' }}>남은 재시험 횟수</StyledTableCell>
                        <StyledTableCell colSpan={this.state.maxCount.length} style={{ textAlign: 'center' }}>
                          {3 - Number(this.props.quizCnt)}
                        </StyledTableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              )}
            </TableContainer>
            <div className={classes.passInfo}>
              * 6문제 이상 맞으셔야 합격입니다.
              <br />* 불합격 시, 재시험 기회는 2회 주어집니다.
            </div>
          </DialogContent>
          <DialogActions>
            <Grid container justify="center">
              {/* <Button onClick={() => this.handleClose('Y')} color="primary">
                재시험
              </Button> */}
              <Button onClick={() => this.handleClose('N')} color="primary" autoFocus>
                확인
              </Button>
            </Grid>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(QuizResDialog);
